export default function (): void {
  const form = document.getElementById('filter-offers') as HTMLFormElement

  if (form) {
    const submitEl = form.querySelector('[type="submit"]') as HTMLButtonElement

    document.querySelectorAll<HTMLInputElement>('input[name="filter_offers[sortBy]"]').forEach((el) => {
      el.addEventListener('change', function () {
        submitEl.click()
      })
    })
  }
}
